export function plural(n: number, one: string, many = `${one}s`): string {
  return n === 1 ? one : many
}
